import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import Notification from '../../Helpers/Notification';
import Helpers from '../../Helpers/Helpers';
import { Link, useNavigate } from "react-router-dom";
import '../../styles/auth.css';
// Import Bootstrap 5.3.3 JavaScript for interactive components
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const Login = ({ title }) => {
  const navigate = useNavigate();
  const helpers = Helpers()
  const [input, setInput] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    document.title = title;
  }, [title]);

  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    fade: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    swipeToSlide: true,
    touchMove: true,
    accessibility: true,
    beforeChange: (current, next) => setCurrentSlide(next),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          fade: true,
          swipeToSlide: true,
          touchMove: true,
          touchThreshold: 5,
          swipe: true,
          draggable: true,
          speed: 600,
          autoplaySpeed: 4000,
        }
      },
      {
        breakpoint: 480,
        settings: {
          dots: true,
          fade: true,
          swipeToSlide: true,
          touchMove: true,
          touchThreshold: 3,
          swipe: true,
          draggable: true,
          speed: 500,
          autoplaySpeed: 4000,
        }
      }
    ]
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await helpers.httpRequest('/auth/login', 'POST', input);

      Notification(response.status, response.message);
      setLoading(false);

      if (response.status === 'error') return;

      helpers.setStorage('user', response.user);
      helpers.setStorage('accessToken', response.accessToken);
      helpers.setStorage('isAuthenticated', true);

      setTimeout(() => {
        navigate('/');
      }, 1500);
    } catch (error) {
      setLoading(false);
      Notification('error', 'An unexpected error occurred.');
      console.error('Login error:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };

  const carouselSlides = [
    {
      image: "assets/images/Astro_Logo.png",
      title: "AstroScope",
      subtitle: "Cosmic Insights & Predictions"
    },
    {
      image: "assets/images/Antara.jpg", 
      title: "Antara",
      subtitle: "Spiritual Guidance & Wisdom"
    },
    {
      image: "assets/images/Astro_Logo.png",
      title: "Premium Services",
      subtitle: "Personalized Astrology Solutions"
    }
  ];

  return (
    <div className="login-container">
      {/* Carousel Background */}
      <div className="carousel-background">
        <Slider ref={sliderRef} {...settings} className="background-slider">
          {carouselSlides.map((slide, index) => (
            <div key={index} className="carousel-slide">
              <div className="slide-background">
                <img 
                  src={slide.image} 
                  alt={slide.title}
                  className="slide-image"
                  loading="eager"
                />
                <div className="slide-overlay"></div>
              </div>
              <div className="slide-content">
                <h2 className="slide-title">{slide.title}</h2>
                <p className="slide-subtitle">{slide.subtitle}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {/* Login Card */}
      <div className="login-card-overlay">
        <div className="login-card">
          {/* Dual Logo Header */}
          <div className="dual-logo-header">
            <div className="logo-container">
              <img 
                src="assets/images/Astro_Logo.png" 
                alt="AstroScope" 
                className="header-logo primary"
              />
              <img 
                src="assets/images/Antara.jpg" 
                alt="Antara" 
                className="header-logo secondary"
              />
            </div>
            <div className="brand-text">
              <h3>AstroScope & Antara</h3>
              <p>Unlock Your Cosmic Destiny</p>
            </div>
          </div>

          {/* Login Content */}
          <div className="login-content-section">
            <div className="welcome-text">
              <h1>Welcome Back</h1>
              <p>Sign in to explore your cosmic journey</p>
            </div>

            <form onSubmit={handleLogin} className="login-form">
              <div className="input-group mb-3">
                <label htmlFor="username" className="input-label">
                  <i className="fas fa-user label-icon"></i>
                  Username
                </label>
                <div className="input-wrapper">
                  <input
                    type="text"
                    id="username"
                    name="username"
                    value={input.username}
                    onChange={handleChange}
                    placeholder="Enter your username"
                    required
                    disabled={loading}
                    className="form-input form-control"
                  />
                  <div className="input-focus-border"></div>
                </div>
              </div>

              <div className="input-group mb-3">
                <label htmlFor="password" className="input-label">
                  <i className="fas fa-lock label-icon"></i>
                  Password
                </label>
                <div className="input-wrapper">
                  <input
                    type="password"
                    id="password"
                    name="password"
                    value={input.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    required
                    disabled={loading}
                    className="form-input form-control"
                  />
                  <div className="input-focus-border"></div>
                </div>
              </div>

              <div className="form-extras d-flex justify-content-between align-items-center mb-4">
                <div className="form-check">
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    id="rememberMe"
                  />
                  <label className="form-check-label" htmlFor="rememberMe">
                    Remember me
                  </label>
                </div>
                <Link to="/forgot-password" className="forgot-link">
                  Forgot Password?
                </Link>
              </div>

              <button 
                type="submit" 
                className={`submit-btn btn btn-primary w-100 ${loading ? 'loading' : ''}`}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="spinner-border spinner-border-sm me-2" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    Signing In...
                  </>
                ) : (
                  <>
                    Sign In
                    <i className="fas fa-arrow-right ms-2 btn-arrow"></i>
                  </>
                )}
              </button>
            </form>

            <div className="signup-prompt text-center">
              <span>Don't have an account? </span>
              <Link to="/register" className="signup-link">Create one</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;

